import React from 'react';
import TopNav from '../../components/layouts/user/topnav';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import AdminSider from '../../components/layouts/admin/sider';
import styles from './styles.module.scss';
import useGetProfileData from '../../hooks/GetProfileData';
import {
  UserDesignationDataContext,
  UserProfileDataContext,
  IsAdminContext,
  ProfilePictureContext,
} from '../../context';
import { Content } from 'antd/es/layout/layout';

const AdminProfile: React.FC = (): JSX.Element => {
  const [
    userProfileData,
    setUserProfileData,
    userDesignationData,
    setUserDesignationData,
    userProfilePictureData,
    setUserProfilePictureData,
  ] = useGetProfileData();

  return (
    <UserProfileDataContext.Provider
      value={{ userProfileData, setUserProfileData }}
    >
      <UserDesignationDataContext.Provider
        value={{ userDesignationData, setUserDesignationData }}
      >
        <ProfilePictureContext.Provider
          value={{ userProfilePictureData, setUserProfilePictureData }}
        >
          <IsAdminContext.Provider value={'1'}>
            <Layout className={styles.layout} style={{ minHeight: '100vh' }}>
              <AdminSider />
              <Layout className={styles.layout}>
                <TopNav {...{ type: 'admin' }} />
                <Layout
                  className={styles.layout}
                  style={{ marginLeft: '122px' }}
                >
                  <Outlet />
                </Layout>
              </Layout>
            </Layout>
          </IsAdminContext.Provider>
        </ProfilePictureContext.Provider>
      </UserDesignationDataContext.Provider>
    </UserProfileDataContext.Provider>
  );
};

export default AdminProfile;
